<template>
  <div class="user-info-container">
    <AccountInfo v-if="isShowAccountData"/>
    <UserInfoList/>
  </div>
</template>

<script>
  import UserInfoList from './UserInfoList'
  import AccountInfo from './AccountInfo'
  import {mapGetters} from 'vuex'

  export default {
    name: 'UserInfo',
    components: {
      UserInfoList,
      AccountInfo
    },
    computed: {
      ...mapGetters('order', [
        'getIsAuthorized',
        'getPersonalTypeSelected'
      ]),
      isShowAccountData: function () {
        return !this.getIsAuthorized &&
          this.getPersonalTypeSelected !== undefined &&
          this.getPersonalTypeSelected['id'] === 2
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/UserInfo/UserInfo.vue